/**
 * Class description
 *
 * Created: 2019-07-30
 * @author jonas
 */
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";

export class BookOfShadowsTextStyles {

    public static FS_OUTRO_COUNT_UP: BitmapTextStyleOptions = {
        font: {
            name: "NumbersWinCountUp",
            size: 24
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static WIN_COUNT_UP: BitmapTextStyleOptions = {
        font: {
            name: "NumbersWinCountUp",
            size: 40
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static DEFAULT_SCREEN_TEXT: PIXI.TextStyle = new PIXI.TextStyle({
        fill: "#000",
        fontFamily: "Open Sans",
        fontSize: 32,
        fontStyle: FontStyle.NORMAL,
        fontWeight: FontWeight.EXTRA_BOLD
    });

    public static BETLINE_WIN_AMOUNT: BitmapTextStyleOptions = {
        font: {
            name: "NumbersWinCountUp",
            size: 10
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };
}